<template>
  <div :class="['search_content', showNoticeBar?'showNoticeBar':'']">
    <div class="search_input_box">
        <form action  @submit.prevent="toSearch">
          <div class="search_input">
            <i class="iconfont select-all" @click="toSearch">&#xe60e;</i>
            <input
                  class="form-control search-field"
                  type="text"
                  name="q"
                  v-model.trim="keyWords"
                  placeholder=""
                  autocomplete="off"
                />
            <i class="iconfont clsose_dialog clearKeywordMin select-all" @click="hideSearchLayer">&#xe615;</i>
            <i v-if="keyWords!=''" class="iconfont clsose_dialog clearKeywordMax  select-all" @click="clearKeyword">&#xe633;</i>
          </div>
        </form>
    </div>
    <div class="search_result"  @scroll="scrollEvent">
        <div  :class="((keyWordList && keyWordList.length) || showResult)?'show_vategoty':''">
        <!-- 搜索有结果 -->
        <template v-if="keyWordList && keyWordList.length">
          <div class="search_item_box">
            <div class="result_title hasResult">相关商品 <span class="length">({{keyWordList.length}})</span></div>
            <div class="ms-row">
              <div class="col-xs-6 col-md-4" v-for="(item,index) in keyWordList" :key="index">
                <BaseItem :source="item" :enableFavorite="false" :enableBuyNow="true" @hideSearchLayer="hideSearchLayer" />
              </div>
            </div>
          </div>
          <div class="more" v-if="keyWordList && keyWordList.length && isNoMore">
              没有更多内容了
          </div>
          <!-- <div class="list-btm__spliter">1</div> -->
        </template>
        <!-- 搜索无结果 -->
        <template v-else>
          <div v-if="showResult" class="no_result">
            没有找到相关的商品
          </div>
          <div class="search_item_box" v-if="!showResult&&keyWordsArr&&keyWordsArr.length">
            <div class="result_title">历史搜索
              <i class="iconfont delete select-all" @click="deleteHistory">&#xe671;</i>
            </div>
            <div class="result_item_box">
              <template v-for="(item,index) in keyWordsArr">
                <span class="result_item" v-if="item!=''"  :key="index" @click="searchKey(item)">{{item}}</span>
              </template>
            </div>
          </div>
          <div class="search_item_box" v-if="showResult" >
            <div class="result_title" style="text-align:center">为您推荐</div>
            <Recommend region="account_rec" :isTitle="false"  @hideSearchLayer="hideSearchLayer"/>
          </div>
          <!-- 热门搜索 -->
          <div class="search_item_box" v-if="hots&&hots.length&&!showResult">
            <div class="result_title">热门搜索</div>
            <div class="result_item_box" :class="moreFlag?'result_item_box_hot':''" ref="element">
              <template v-for="(item,index) in hots">
                <span class="result_item" v-if="item!=''"  :key="index" @click="searchKey(item)">{{item}}</span>
              </template>
            </div>
            <div class="look_all" v-if="moreFlag" @click="toLookAll">
                <span>查看全部</span>
                <i class="iconfont select-all">&#xe636;</i>
            </div>
          </div>
        </template>
        <!-- 畅销榜单 -->
        <div class="search_item_box" v-if="showHotSale && hotSaleArr && hotSaleArr.length">
          <div class="result_title">畅销榜单</div>
          <div class="sell_box">
            <div class="sell_item" @click="toJump(item.link)" v-for="(item, index) in hotSaleArr" :key="index">
              <div class="sell_img">
                <img :src="item.img" alt="">
              </div>
              <div class="sell_msg">{{item.title}}</div>
            </div>
          </div>
        </div>
        <!-- 分类 -->
        <div class="category_box" v-if="(keyWordList && keyWordList.length) || showResult">
          <div class="cat_title">分类</div>
          <div class="nav-items" @click="hideSearchLayer">
            <div class="nav-item" v-for="item in navList" :key="item.id">
              <a href="javascript:void(0);" @click="actionHandler(item.action)">{{item.text}}</a>
            </div>
          </div>
        </div>
    </div>
    </div>
  </div>
</template>
<script>
import Recommend from '@/components/Recommend.vue';
import BaseItem from '@/components/BaseItem';
import utils from "@/utils/index";
import api from "@/utils/api";
import types from "@/store/types";
import actionMixins from '@/utils/action.mixins';
export default {
  components: { Recommend, BaseItem },
  name: "Search",
  props: ['showNoticeBar'],
  mixins: [actionMixins],
  data() {
    return {
      activeIndex: 0,
      lookAll: false,
      keyWords:'',
      keyWordsArr: null,
      hots: [],
      hotsAll:[],
      keyWordList:[],
      sellWell:[],
      showResult:false,
      isNoMore:false,
      pageObj: { //分页器
        curPage: 1,
        totalPage: null
      },
      moreFlag:false,
      hotSaleArr:[],
      showHotSale:true
    };
  },
  created() {
    let keyWordsArr = localStorage.getItem('keyWords')
    if(keyWordsArr && keyWordsArr.length){
      this.keyWordsArr = keyWordsArr.split(',')
    }
    this.hotMsg()
    this.hotSale()
  },
  methods: {
    switchTab(index) {
      this.activeIndex = index;
    },
    toLookAll() {
      this.moreFlag = false
    },
    hideSearchLayer() {
      this.$emit('hideSearchLayer')
    },
    toSearch() {
      if(this.keyWords==''){
        return
      }
      this.keyWordList=[]
      this.pageObj.curPage =1
      this.searchKey(this.keyWords);
      // 
      utils.bdTracker('search', { search_word: this.keyWords });
    },
    saveHistory(keyWord){
      let keyWordsArr = this.keyWordsArr
      if(!this.keyWordsArr) {
        keyWordsArr = []
      }
      if (keyWordsArr.indexOf(keyWord) == -1) {
        keyWordsArr.unshift(keyWord)
        this.keyWordsArr=keyWordsArr
      }else{
        keyWordsArr.splice( keyWordsArr.indexOf(keyWord),1)
        keyWordsArr.unshift(keyWord)
      }
      localStorage.setItem('keyWords', keyWordsArr.join(','))
    },
    deleteHistory() {
      this.keyWordsArr=[]
      localStorage.removeItem( 'keyWords')
    },
    //热门搜索
    hotMsg(){
      api[types.HOTKEYWORDS]().then(res => {
        this.hots = res.data
        this.$nextTick(()=>{
          if(this.$refs.element.offsetHeight>170){
            this.moreFlag = true
          }
        })
      }).catch();
    },
    //热销榜单
    hotSale(){
      api[types.HOT_SALE]().then(res => {
       console.log(res)
       if(res.code==1){
         this.hotSaleArr = res.data
       }
      }).catch();
    },
    //搜索
    searchKey(key){
      this.keyWords=key
      this.saveHistory(key)
      let _data = {
        keyword: key,
        page: this.pageObj.curPage
      }
      api[types.KEYWORDLIST](_data).then(res => {
        this.saveHistory(this.keyWords)
        if(res.data.type && res.data.type != 'search'){
          let path = '';
          if(res.data.type=='product'){   // 商品详情
            path = `/detail?id=${res.data.code}`;
          } else if(res.data.type=='cat'){  // 列表页
            path = `/category/${res.data.code}`;
          } else if(res.data.type=='project'){ // 活动页
            path = `/landing?key=${res.data.code}`;
          }
          this.$router.push({ path });
          return
        }
        this.pageObj.curPage= res.data.curPage,
        this.pageObj.totalPage= res.data.totalPage
        if(res.data.list==0){
          this.showResult=true
          return
        }
        if (res.data.list.length > 0) {
          this.keyWordList = this.keyWordList.concat(res.data.list);
        }
        if (res.data.totalPage == res.data.curPage) {
          this.isNoMore = true
        }
        this.showHotSale = false;
        // 
        this.gtmTrackSearch(key, res.data.count);
      }).catch();
    },
    // 滚定监听
    scrollEvent(e) {
      if(this.keyWordList.length==0) return
      if (
        e.currentTarget.scrollTop + e.currentTarget.clientHeight >=
        e.currentTarget.scrollHeight
      ) {
        // this.isNoMore=false
        let _curPage = this.pageObj.curPage;
        let _totalPage = this.pageObj.totalPage;
        if (_curPage == _totalPage) {
          this.isNoMore = true
          return;
        }
        this.pageObj.curPage = ++_curPage;
        this.searchKey(this.keyWords);
      }
    },
    clearKeyword(){
      this.keyWords = ''
    },
    toJump(link){
      window.location.href = link
    },
    getItemSKUID(item) {
      let targetId = -1; // SKU_ID or Unique_ID+SKU1_ID+SKU2_ID+...
      // 组合礼盒
      if (item.display_type == "collection") {
        targetId = `{{${item.unique_id}}}${item.products.reduce((pre,cur)=>{
          return pre + `{{${cur.skus?.[0]?.sku_id}}}`
        }, '')}`;
      } else if (item.display_type == "collection_sku") {
        targetId = item.skus?.[0]?.sku_id;
      } else if (["capacity_ml", "capacity_g", "color"].indexOf(item.display_type) != -1) {
        targetId = item.skus?.[0]?.sku_id;
      } else {
        targetId = item.skus?.[0]?.sku_id;
      }
      return targetId;
    },
    // GTM
    gtmTrackSearch(key, count) {
      if (!window.dataLayer) return false;
      window.dataLayer.push({
        siteCountry: 'CN',
        siteLanguage: 'CN',
        searchQuery: key || '',
        searchResults: count || 0,
        pageCategory: 'Search_Results'
      });
      window.dataLayer.push({
        ecommerce: {
          currencyCode: 'CNY',
          impressions: this.keyWordList.map((item, i) => {
            return {
              id: this.getItemSKUID(item),
              list: 'Search_Results',
              productType: ['collection', 'collection_sku'].indexOf(item.display_type) != -1 ? 'bundle' : item?.skus?.length > 1 ? 'configured' : 'simple',
              position: i
            }
          })
        }
      });
    }
  },
  computed:{
    navList() {
      return this.$store.getters.navList;
    },
  }
};
</script>

<style lang="scss" scoped>
.search_content{
    position: fixed;
    width: 100%;
    height: 100%;
    background: #fff;
    z-index: 9;
    top: 63px;
    left: 0;
    &.showNoticeBar{
      top: 123px;
    }
    padding-bottom: 3.125rem;
    .search_input_box{
        background: #f5f5f5;
        height: 3.75rem;
        padding: .625rem 1.125rem;
        form{
          width: 100%;
          height: 100%;
        }
        .search_input{
          display: flex;
          align-items: center;
          border-radius: 3.125rem;
          background: #fff;
          width: 100%;
          height: 100%;
          .iconfont{
            font-size: 1.25rem;
            margin-left: 1.3125rem;
            margin-right: .625rem;
            cursor: pointer;
          }
          .search-field{
            flex: 1;
          }
          .clsose_dialog{
            font-size: 1.25rem;
            margin-left: .625rem;
            margin-right: 1.3125rem;
            cursor: pointer;
          }
          .clearKeywordMax{
            display: none;
          }
          .clearKeywordMin{
            display: block;
          }
        }
    }
    .search_result{
      padding: 1.875rem 1.25rem;
      overflow-y: auto;
      height: calc(100% - 100px);
      .list-btm__spliter { height: 10px; }
      .more{
        text-align: center;
        font-size: .75rem;
      }
      .no_result{
        height: 3.375rem;
        text-align: center;
        font-size: .875rem;
        color: #333;
        border-bottom: .0625rem solid #DFDFDF;
        margin-bottom: 1.875rem;
      }
      .search_item_box{
        padding-bottom: 1.875rem;
        .ms-row{
          display: flex;
          flex-wrap: wrap;
        }
      }
      .result_title{
        font-size: .875rem;
        color: #000;
        margin-bottom: 1.25rem;
        position: relative;
        .delete{
          position: absolute;
          right: .625rem;
          top: 0;
          font-size: 1rem;
          color: #999;
          cursor: pointer;
        }
        &.hasResult{
          color: #6D6D6D;
          border-bottom: .0625rem solid #DFDFDF;
          padding-bottom: .625rem;
          .length{
            padding-left: .3125rem;
            font-size: .875rem;
          }
        }
      }
      .result_item_box{
          overflow: hidden;
          display: flex;
          flex-wrap: wrap;
          justify-content: flex-start;
          transition: all 0.3s;
          &.look_all_box{
            max-height: inherit;
          }
        .result_item{
          background: #f5f5f5;
          color: #575757;
          border-radius: 3.125rem;
          padding: 0 1.25rem;
          height: 2.625rem;
          line-height: 2.625rem;
          margin-right: .9375rem;
          display: inline-block;
          margin-bottom: .9375rem;
          cursor: pointer;
        }
      }
      .result_item_box_hot{
        max-height: 10.6875rem;
      }
      .look_all{
        display: flex;
        align-items: center;
        padding-top: .625rem;
        color: #575757;
        font-size: .75rem;
        justify-content: center;
        .iconfont{
          font-size: 1.25rem;
          transform: rotate(90deg);

        }
      }
      .sell_box{
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        .sell_item{
          width: 50%;
          display: flex;
          height: 3.125rem;
          align-items: center;
          margin-bottom: .9375rem;
          .sell_img{
            width: 3.125rem;
            height: 3.125rem;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #f5f5f5;
            border-radius: .625rem;
            img{
              max-width: 100%;
              max-height: 100%;
            }
          }
          .sell_msg{
            padding-left: .625rem;
            font-size: .75rem;
            color: #3A3A3A;
          }
        }
      }
    }

}
.category_box{
  margin-top: 1.875rem;
  .cat_title{
    font-size: .875rem;
    color: #2D2D2D;
    margin-bottom: 1.25rem;
  }
  .nav-items{
    display: flex;
      flex-wrap: wrap;
    .nav-item{
      width: 50%;
      margin-bottom: .9375rem;
      a{
        text-decoration: none;
        font-size: .75rem;
        color: #282828;
      }
    }
  }
}
.search_content /deep/  .plugin-wrapper { padding-bottom: 1.875rem }
@media only screen and (min-width: 64rem) {
.search_content{
    position: absolute;
    width: 100%;
    height: 100%;
    background: #fff;
    z-index: 9;
    top: 100px;
    left: 0;
    // padding-bottom: 3.125rem;
    .search_input_box{
        height: 2.5rem;
        padding: .625rem 0;
        margin: 0 10.1875rem;
        border-radius: 3.125rem;
        form{
          width: 100%;
          height: 100%;
        }
        .search_input{
          display: flex;
          align-items: center;
          border-radius: 3.125rem;
          overflow: hidden;
          background: #f5f5f5;
          width: 100%;
          height: 100%;
          .iconfont{
            font-size: 1.25rem;
            margin-left: 1.3125rem;
            margin-right: .625rem;
          }
          .search-field{
            flex: 1;
            background: #f5f5f5;
          }
          .clsose_dialog{
            font-size: 1.25rem;
            margin-left: .625rem;
            margin-right: 1.3125rem;
          }
          .clearKeywordMin{
            display: none;
          }
          .clearKeywordMax{
            display: block;
          }
        }
    }
    .search_result{
      padding: 1.875rem 10.1875rem;
      overflow-y: auto;
      height: calc(100% - 100);
      // padding-bottom: 200px;
      .list-btm__spliter { height: 10px; }
      .show_vategoty{
        padding-left: 8.125rem;
        position: relative;
      }
      .more{
        text-align: center;
        font-size: .75rem;
      }
      .no_result{
        height: 3.375rem;
        text-align: center;
        font-size: .875rem;
        color: #333;
        border-bottom: .0625rem solid #DFDFDF;
        margin-bottom: 1.875rem;
      }
      .search_item_box{
        padding-bottom: 1.875rem;
        .ms-row{
          display: flex;
          flex-wrap: wrap;
        }
      }
      .result_title{
        font-size: .875rem;
        color: #000;
        margin-bottom: 1.25rem;
        position: relative;
        .delete{
          position: absolute;
          right: .625rem;
          top: 0;
          font-size: 1rem;
          color: #999;
        }
        &.hasResult{
          color: #6D6D6D;
          border-bottom: .0625rem solid #DFDFDF;
          padding-bottom: .625rem;
          .length{
            padding-left: .3125rem;
            font-size: .875rem;
          }
        }
      }
      .result_item_box{
          overflow: hidden;
          display: flex;
          flex-wrap: wrap;
          justify-content: flex-start;
          transition: all 0.3s;
          &.look_all_box{
            max-height: inherit;
          }
        .result_item{
          background: #f5f5f5;
          color: #575757;
          border-radius: 3.125rem;
          padding: 0 1.25rem;
          height: 2.625rem;
          line-height: 2.625rem;
          margin-right: .9375rem;
          display: inline-block;
          margin-bottom: .9375rem;
        }
      }
      .look_all{
        display: flex;
        align-items: center;
        padding-top: .625rem;
        color: #575757;
        font-size: .75rem;
        justify-content: center;
        .iconfont{
          font-size: 1.25rem;
          transform: rotate(90deg);

        }
      }
      .sell_box{
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        .sell_item{
          width: 50%;
          display: flex;
          height: 3.125rem;
          align-items: center;
          margin-bottom: .9375rem;
          .sell_img{
            width: 3.125rem;
            height: 3.125rem;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #f5f5f5;
            border-radius: .625rem;
            img{
              max-width: 100%;
              max-height: 100%;
            }
          }
          .sell_msg{
            padding-left: .625rem;
            font-size: .75rem;
            color: #3A3A3A;
          }
        }
      }
    }
}
.category_box{
  margin-top: 1.875rem;
  position: absolute;
  left: 0;
  top: 0;
  .cat_title{
    font-size: .875rem;
    color: #2D2D2D;
    margin-bottom: 1.25rem;
  }
  .nav-items{
    display: flex;
      flex-wrap: wrap;
    .nav-item{
      width: 100%;
      margin-bottom: .9375rem;
      a{
        text-decoration: none;
        font-size: .75rem;
        color: #282828;
      }
    }
  }
}
}
</style>